import { PayloadAction } from '@reduxjs/toolkit';

import { handleError } from '../../../../shared/common/HandleErrors';
import { getEnvBaseUrl } from '../../../../shared/common/helpers';
import { Axios } from '../../../../shared/common/http';
import { AppDispatch, AppThunk, RootState } from '../../../../shared/store';
import { CensusState, CqmGapHintDto, CqmStatusRowDto } from './models';
import { censusSlice } from './slice';

export type { CqmGapHintDto, CqmStatusRowDto };

export const reducers = {
    setCqmStatusRows: (state: CensusState, action: PayloadAction<CqmStatusRowDto[]>) => {
        state.cqmStatusRows = action.payload;
    },

    clearCqmStatusRows: (state: CensusState) => {
        state.cqmStatusRows = null;
    },
};

export function fetchCqmStatusRows(patientId: number, year: number): AppThunk {
    return async (dispatch: AppDispatch) => {
        try {
            const baseUrl = getEnvBaseUrl();
            const response = await Axios.get(`${baseUrl}/api/Cqm/GetStatusRows/${patientId}/${year}`);
            const data = response?.data;
            const rows: CqmStatusRowDto[] = Array.isArray(data?.entity)
                ? data.entity
                : Array.isArray(data)
                    ? data
                    : [];
            dispatch(censusSlice.actions.setCqmStatusRows(rows));
        } catch (error) {
            handleError(error, () => { });
        }
    };
}

export const selectCqmStatusRows = (state: RootState) => state.census.cqmStatusRows;
